import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';
import {Timer} from '../../../utils/timer';

@Component({
  selector: 'app-identifier-input',
  templateUrl: './identifier-input.component.html',
  styleUrls: ['./identifier-input.component.css', '../../../../assets/styles/form-styles.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    multi: true,
    useExisting: forwardRef(() => IdentifierInputComponent)
  }]
})
export class IdentifierInputComponent implements ControlValueAccessor {
  @Input()
  name: string;
  @Input()
  readonly: boolean;
  @Input()
  placeholder: string;
  @Input()
  maxlength: number;
  @Input()
  uppercase: boolean;
  @Input()
  control: NgModel;
  @Input()
  editDisabled: boolean;

  @Output()
  otpRequest = new EventEmitter<string>();

  isResendOtpTimerTicking: boolean;
  otpSentForValue: string;
  private notifyIdentifierChanged: (identifierValue: string) => {};

  constructor(private timer: Timer) {
  }

  private _inputValue: string;

  public get inputValue(): string {
    return this._inputValue;
  }

  public set inputValue(value: string) {
    this._inputValue = value;
    this.notifyIdentifierChanged(value);
  }

  async onSendOtpButtonClick(): Promise<void> {
    this.otpSentForValue = this.inputValue;
    this.otpRequest.emit(this.inputValue);

    this.isResendOtpTimerTicking = true;
    this.timer.set(30000, () => {
      this.isResendOtpTimerTicking = false;
    });
  }

  getOtpButtonLabel(): string {
    return (this.otpSentForValue && !this.isInputValueModified()) ? 'Resend OTP' : 'Send OTP';
  }

  isOtpButtonEnabled(): boolean {
    if (!this.inputValue || this.control.errors) {
      return false;
    }

    if (!this.otpSentForValue || !this.isResendOtpTimerTicking) {
      return true;
    }

    return this.isInputValueModified();
  }

  registerOnChange(fn: any): void {
    this.notifyIdentifierChanged = fn;
  }

  writeValue(identifierValue: string): void {
    this._inputValue = identifierValue;
  }

  registerOnTouched(fn: any): void {
  }

  private isInputValueModified() {
    return (this._inputValue !== this.otpSentForValue);
  }
}
